
import { isImageUrl, isImageTargetUrl } from './imageValidation';
import { isFeedbackAnalysis } from './feedbackDetection';

export const extractImageUrls = (text: string) => {
  console.log('🖼️ imageExtraction: Starting extractImageUrls with text length:', text.length);
  console.log('🖼️ imageExtraction: Text preview (first 200 chars):', text.substring(0, 200));
  
  // Check if this is feedback analysis content
  const isFeedback = isFeedbackAnalysis(text);
  console.log('🖼️ imageExtraction: Is feedback analysis?', isFeedback);
  
  const urlPattern = /(https?:\/\/[^\s\)\]\<\>\"\']+)/gi;
  const urls = text.match(urlPattern) || [];
  console.log('🖼️ imageExtraction: Found URLs:', urls);
  
  const imageUrls = urls.filter(isImageUrl);
  console.log('🖼️ imageExtraction: Filtered image URLs:', imageUrls);
  
  // Also look for "Image URL: " and "IMAGE_URL:" patterns specifically
  const imageUrlPattern = /(?:Image URL:|IMAGE_URL:)\s*(https?:\/\/[^\s\)\]\<\>\"\']+)/gi;
  const imageUrlMatches = [...text.matchAll(imageUrlPattern)];
  const extractedImageUrls = imageUrlMatches.map(match => match[1]);
  console.log('🖼️ imageExtraction: Extracted image URLs with pattern:', extractedImageUrls);
  
  // CRITICAL FIX: Extract URLs from markdown image syntax ![alt](url) 
  const markdownImagePattern = /!\[[^\]]*\]\(([^)]+)\)/g;
  const markdownImageMatches = [...text.matchAll(markdownImagePattern)];
  const markdownImageUrls = markdownImageMatches.map(match => {
    console.log('🖼️ imageExtraction: Found markdown match:', match[0], 'URL:', match[1]);
    return match[1];
  }).filter(url => {
    const isValid = isImageUrl(url);
    console.log('🖼️ imageExtraction: Validating URL:', url, 'isValid:', isValid);
    return isValid;
  });
  console.log('🖼️ imageExtraction: Final markdown image URLs:', markdownImageUrls);
  
  // Look for target URLs in feedback responses (REVEALED TARGET: pattern)
  const targetUrlPattern = /REVEALED TARGET:\s*(https?:\/\/[^\s\)\]\<\>\"\']+)/gi;
  const targetUrlMatches = [...text.matchAll(targetUrlPattern)];
  const targetImageUrls = targetUrlMatches
    .map(match => match[1])
    .filter(isImageTargetUrl);
  console.log('🖼️ imageExtraction: Found target image URLs:', targetImageUrls);
  
  // Combine all types of image URLs and remove duplicates
  const allImageUrls = [...new Set([...imageUrls, ...extractedImageUrls, ...targetImageUrls, ...markdownImageUrls])];
  console.log('🖼️ imageExtraction: Final combined image URLs:', allImageUrls);
  
  let cleanedText = text;
  
  // CRITICAL: For feedback analysis, preserve ALL formatting - only remove image URLs, not any whitespace
  if (isFeedback) {
    console.log('🖼️ imageExtraction: Preserving feedback analysis formatting - minimal URL removal only');
    allImageUrls.forEach(imageUrl => {
      // Only remove the URL itself and immediate prefixes, preserve all line breaks and formatting
      cleanedText = cleanedText.replace(imageUrl, '');
      cleanedText = cleanedText.replace(/Image URL:\s*/, '');
      cleanedText = cleanedText.replace(/REVEALED TARGET:\s*/, '');
    });
    // CRITICAL FIX: Remove complete markdown image syntax ![alt](url) for feedback
    cleanedText = cleanedText.replace(/!\[[^\]]*\]\([^)]+\)/g, '');
    // For feedback, do NOT clean up any whitespace - preserve everything
  } else {
    // For non-feedback content, apply normal cleaning
    allImageUrls.forEach(imageUrl => {
      cleanedText = cleanedText.replace(imageUrl, '').trim();
      cleanedText = cleanedText.replace(/Image URL:\s*/, '').trim();
      cleanedText = cleanedText.replace(/IMAGE_URL:\s*/, '').trim();
      cleanedText = cleanedText.replace(/REVEALED TARGET:\s*/, '').trim();
    });
    // CRITICAL FIX: Remove complete markdown image syntax ![alt](url) for non-feedback
    cleanedText = cleanedText.replace(/!\[[^\]]*\]\([^)]+\)/g, '');
    // Clean up any extra whitespace for non-feedback content
    cleanedText = cleanedText.replace(/\s+/g, ' ').trim();
  }
  
  console.log('🖼️ imageExtraction: Cleaned text length after URL removal:', cleanedText.length);
  console.log('🖼️ imageExtraction: Cleaned text preview (first 200 chars):', cleanedText.substring(0, 200));
  
  return {
    text: cleanedText,
    images: [], // Always include images array
    imageUrls: allImageUrls
  };
};
